// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 16:38:59

export default {
  "id": "fix-the-hoof",
  "slug": "fix-the-hoof",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/247187e3dc3d43a9a707e725d4324991-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/247187e3dc3d43a9a707e725d4324991/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Fix The Hoof",
      "description": "Fix The Hoof is a soothing simulation game where you take on the role of a hoof care specialist, restoring and beautifying the hooves of animals like horses, cows, and goats. Enjoy deeply satisfying ASMR moments as you clean, polish, and paint hooves in this engaging 3D experience. Earn money from your services to upgrade your farm and expand your collection of animals to care for. ",
      "instructions": "Click on interactive elements on the screen using the mouse or touchpad to clean, polish, and paint hooves. ",
      "genres": [
        "Simulation"
      ],
      "tags": [
        "animal",
        "horse",
        "relax",
        "repair"
      ]
    },
    "zh-CN": {
      "title": "修复蹄子",
      "description": "《修蹄专家》是一款舒缓的模拟游戏，你将扮演蹄甲护理专家，为马、牛、山羊等动物的蹄甲进行修复和美化。在这款引人入胜的3D体验中，享受深度满足的ASMR时刻，清洁、抛光和涂装蹄甲。通过你的服务赚取金钱，升级你的农场并扩大你护理的动物收藏。",
      "instructions": "使用鼠标或触摸板点击屏幕上的交互元素，清洁、抛光和上色蹄子。",
      "genres": [
        "模拟"
      ],
      "tags": [
        "动物",
        "马",
        "放松",
        "修理"
      ]
    },
    "zh-TW": {
      "title": "修復蹄子",
      "description": "修蹄專家是一款舒緩的模擬遊戲，您將扮演蹄子護理專家，為馬、牛、山羊等動物的蹄子進行修復和美化的工作。在這個引人入勝的3D體驗中，享受滿足的ASMR時刻，您將清潔、打蜡和上色蹄子。從您的服務中賺取金錢，升級您的農場並擴展您照顧的動物收藏。",
      "instructions": "使用滑鼠或觸控板點擊螢幕上的互動元素，以清潔、打蜡和上色馬蹄。",
      "genres": [
        "模擬"
      ],
      "tags": [
        "動物",
        "馬",
        "放鬆",
        "修理"
      ]
    },
    "zh-HK": {
      "title": "修好蹄甲",
      "description": "修蹄專家是一款舒緩的模擬遊戲，您將扮演蹄部護理專家，為馬、牛、山羊等動物的蹄子進行修復和美顏。在這個引人入勝的3D體驗中，享受深層次的ASMR時刻，為蹄子清潔、打亮和塗漆。從您的服務中賺取金錢，升級您的農場並擴展您照顧的動物收藏。",
      "instructions": "使用滑鼠或觸控板點擊螢幕上的互動元素，以清潔、磨光和塗漆蹄甲。",
      "genres": [
        "模擬"
      ],
      "tags": [
        "動物",
        "馬",
        "放鬆",
        "修理"
      ]
    },
    "ja": {
      "title": "足を直せ！",
      "description": "Fix The Hoofは、馬、牛、山羊などの動物の蹄のケア専門家としての役割を担い、蹄を修復し、美しくするリラックス系シミュレーションゲームです。この魅力的な3D体験で蹄を洗浄、磨き、塗りながら、満足感のあるASMRの瞬間を楽しみましょう。サービスからお金を稼ぎ、農場をアップグレードし、ケアする動物のコレクションを拡張してください。",
      "instructions": "スクリーンのインタラクティブ要素をマウスやタッチパッドでクリックして蹄を掃除、磨き、塗りましょう。",
      "genres": [
        "シミュレーション"
      ],
      "tags": [
        "動物",
        "馬",
        "リラックス",
        "修理"
      ]
    },
    "ko": {
      "title": "마법의蹄 고치기",
      "description": "Fix The Hoof는 고막 관리 전문가로서 역할을 맡아 말, 소, 양 등 동물의 고막을 복원하고 미화하는 안정적인 시뮬레이션 게임입니다. 이 흥미로운 3D 경험에서 고막을 청소하고 세척하고 칠하는 동안 깊은 만족감을 느끼세요. 서비스로 벌은 돈으로 농장을 업그레이드하고 돌보는 동물들의 컬렉션을 확장하세요.",
      "instructions": "화면에 있는 상호작용 요소를 마우스나 터치패드로 클릭하여 발을 청소하고 세척하고 칠하세요.",
      "genres": [
        "시뮬레이션"
      ],
      "tags": [
        "동물",
        "馬",
        "식대",
        "수리"
      ]
    },
    "fr": {
      "title": "Répare la corne",
      "description": "Fix The Hoof est un jeu de simulation apaisant où vous incarnez un spécialiste de la soins des sabots, en restaurant et en embellissant les sabots d'animaux comme des chevaux, des vaches et des chèvres. Profitez de moments ASMR satisfaisants en nettoyant, polissant et peignant les sabots dans cette expérience immersive en 3D. Gagnez de l'argent avec vos services pour améliorer votre ferme et élargir votre collection d'animaux à prendre en charge.",
      "instructions": "Cliquez sur les éléments interactifs à l'écran avec la souris ou le pavé tactile pour nettoyer, polir et peindre les sabots.",
      "genres": [
        "Simulation"
      ],
      "tags": [
        "animal",
        "cheval",
        "se détendre",
        "réparer"
      ]
    }
  }
};
